import styles from './Field.module.css';

export function Field({ label, error, hint, children, required }) {
  return (
    <label className={styles.field}>
      <span className={styles.label}>
        {label}
        {required && <span className={styles.req}>*</span>}
      </span>
      {children}
      {hint && !error && <span className={styles.hint}>{hint}</span>}
      {error && <span className={styles.error}>{error}</span>}
    </label>
  );
}

export function TextInput(props) {
  return <input className={styles.input} {...props} />;
}

export function Select({ children, ...props }) {
  return (
    <select className={styles.input} {...props}>
      {children}
    </select>
  );
}

export default Field;
